import { Box, Grid, IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { MuiDatagrid } from "../../../../components";
import { GridColDef } from "@mui/x-data-grid";
import { defaultToolbar } from "../../../../components/views/datagrid/MuiDatagrid";
import { isExists } from "../../../../utils";
import { useFormikContext } from "formik";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import InfoIcon from "@mui/icons-material/Info";
import { useState } from "react";
import InternetFrastructureList from "./InternetFrastructureList";
import { productCategoryEnum } from "../../../../utils/enum";
import ToolTip from "../../../../components/tooltip/ToolTip";

interface IOrderLine {
  campaignId: string;
  categoryId: number;
  customerManagementGroupIds: any[];
  ddtechTypeId: string;
  id: string;
  internetAddress?: any[];
  newTypeId?: number;
  paymentTypeId?: number;
  lineTypeId?: number;
  paymentVoiceTypeId?: number;
  serviceTypeId: any;
  phoneInternet?: string;
  productTypeId?: string;
  pstn?: any[];
  pri?: any[];
  bri?: any[];
  staticIp?: boolean;
  phoneNumber?: string;
  circuitNumber?: string;
}
interface IProps {
  data: IOrderLine;
  id: string;
}

const OrderLines = ({ selectedLine, setSelectedLine }: any) => {
  const { values, setFieldValue }: any = useFormikContext();
  const [open, setOpen] = useState<boolean>();
  const [data, setData] = useState();
  const editOrderLine = (data: IOrderLine) => {
    setSelectedLine(data);
    setFieldValue("categoryId", data.categoryId);
    setFieldValue("campaign", data.campaignId);
    setFieldValue("productTypeId", data.productTypeId);
    setFieldValue("paymentVoiceTypeId", data.paymentVoiceTypeId);
    setFieldValue("ddtechType", data.ddtechTypeId);
    setFieldValue("paymentType", data.paymentTypeId);
    setFieldValue(
      "customerManagementGroupIds",
      data.customerManagementGroupIds
    );
    setFieldValue("serviceType", data.serviceTypeId);
    setFieldValue("servicePhone", data.phoneNumber);
    setFieldValue("devreNo", data.circuitNumber);
    setFieldValue("internetAddresses", data.internetAddress);
    setFieldValue("pstnPhoneNumbers", data.pstn);
    setFieldValue("pri", data.pri);
    setFieldValue("bri", data.bri);
  };

  const deleteButtonHandler = (id: string) => {
    const filteredOrderLines = values.orderLines.filter(
      (line: any) => line.id !== id
    );

    setFieldValue("orderLines", filteredOrderLines, false);

    if (isExists(selectedLine)) setSelectedLine(null);
  };

  const getInternetInfrastructureQuery = (data: any) => {
    setOpen(true);
    setData(data);
    /* return (
      <InternetFrastructureList
        internetFrastructure={data}
        open={open}
        setOpen={setOpen}
      />
    ); */
  };
  const columns: GridColDef[] = [
    {
      field: "categoryName",
      headerName: "Ürün/Hizmet Kategorisi",
      flex: 1,
    },
    {
      field: "productName",
      headerName: "Ürün/Hizmet Tipi",
      flex: 1,
    },
    {
      field: "campaignName",
      headerName: "Kampanya/Tarife",
      flex: 1,
      renderCell: (params: any) => {
        return (
          <>
            <ToolTip title={params.row.campaignName}>
              <Typography
                sx={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {params.row.campaignName}
              </Typography>
            </ToolTip>
          </>
        );
      },
    },
    {
      field: "paymentType",
      headerName: "İşlem Türü",
      flex: 1,
    },
    {
      field: "address",
      headerName: "Adres",
      flex: 1,
      renderCell: (params: any) => {
        return (
          <>
            <ToolTip title={params.row.address}>
              <Typography
                sx={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {params.row.address}
              </Typography>
            </ToolTip>
          </>
        );
      },
    },
    {
      field: "internet",
      headerName: "Altyapı",
      flex: 1,
      width: 100,
      maxWidth: 100,
      minWidth: 100,
      renderCell: (params: any) => {
        return (
          <>
            {params.row.internetInfrustructure &&
            params.row.categoryId === productCategoryEnum.connectService ? (
              <IconButton
                color="primary"
                onClick={() =>
                  getInternetInfrastructureQuery(
                    params.row.internetInfrustructure
                  )
                }
              >
                <InfoIcon />
              </IconButton>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      field: "edit",
      headerName: "",
      flex: 1,
      width: 100,
      maxWidth: 100,
      minWidth: 100,
      renderCell: (params: any) => {
        return (
          <>
            <IconButton
              color="primary"
              onClick={() => editOrderLine(params.row)}
            >
              <EditIcon />
            </IconButton>

            <IconButton
              color="error"
              onClick={() => deleteButtonHandler(params.row.id)}
            >
              <DeleteOutlineIcon />
            </IconButton>
          </>
        );
      },
    },
  ];
  return (
    <Grid item md={12}>
      <Grid container spacing={3}>
        <Grid item md={12}>
          <Typography>Sipariş Kalemleri</Typography>
        </Grid>
        <Grid item md={12}>
          <InternetFrastructureList
            internetFrastructure={data}
            open={open}
            setOpen={setOpen}
          />
          <MuiDatagrid
            rows={isExists(values.orderLines) ? values.orderLines : []}
            rowCount={values.orderLines.length}
            loading={false}
            setPagination={() => {}}
            columns={columns}
            hideToolbars={{ ...defaultToolbar, filter: false, create: false }}
            pageNumber={10}
            pageSize={0}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrderLines;
